import { atom } from "recoil"

export const accountRequestIdDeleteState = atom({
  key: "atoms/user/accountRequestIdDeleteState",
  default: 0,
})
